import { Button } from '@sunwebgroup/uds-ui/button'
import { Sheet } from '@sunwebgroup/uds-ui/sheet'
import cn from 'classnames'
import { useIntl } from '@/intl'
import { useBookingDetailsActions } from '@/scopes/account/booking-details/infrastructure/dependencies/dependencies'
import { useBookingDetailsStore } from '../../../infrastructure/useBookingDetailsStore'
import styles from './ParticipantEdit.module.css'
import { PARTICIPANT_EDIT_EXTERNAL_REQUEST_FORM_ID } from './ParticipantEditExternalRequestForm'
import { PARTICIPANT_EDIT_FORM_ID, ParticipantEditForm } from './ParticipantEditForm'

export function ParticipantEdit() {
  const intl = useIntl()
  const { participantEditClosed, participantEditExternalRequestClosed } = useBookingDetailsActions()
  const isOpen = useBookingDetailsStore(state => state.participantEdit.isOpen)
  const loadStatus = useBookingDetailsStore(state => state.participantEdit.loadStatus)
  const submitStatus = useBookingDetailsStore(state => state.participantEdit.submitStatus)
  const externalRequest = useBookingDetailsStore(state => state.participantEdit.externalRequest)
  const changeActiveParticipantId = useBookingDetailsStore(state => state.changeActiveParticipantId)
  const isSubmitting = submitStatus === 'loading' || externalRequest.submitStatus === 'loading'

  function handleOpenChange(open: boolean) {
    if (!open && !isSubmitting) {
      participantEditClosed()
      changeActiveParticipantId('')
    }
  }

  return (
    <Sheet.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Sheet.Body side="right">
        <Sheet.Header
          className={cn(isSubmitting && styles.headerDisabled)}
          closeLabel={intl.formatMessage({ id: 'close' })}
          titleLabel={intl.formatMessage({ id: 'common_edit' })}
        />
        <Sheet.Content className={styles.sheetContent}>
          <ParticipantEditForm />
        </Sheet.Content>
        <Sheet.Footer>
          <Button
            type="submit"
            form={externalRequest.isOpen ? PARTICIPANT_EDIT_EXTERNAL_REQUEST_FORM_ID : PARTICIPANT_EDIT_FORM_ID}
            disabled={isSubmitting || loadStatus !== 'success'}
          >
            {intl.formatMessage({ id: 'save_button_text' })}
          </Button>
          <Button
            variant="transparentNeutral"
            onClick={externalRequest.isOpen ? participantEditExternalRequestClosed : participantEditClosed}
            type="button"
            disabled={isSubmitting}
          >
            {intl.formatMessage({ id: 'common_cancel_button' })}
          </Button>
        </Sheet.Footer>
      </Sheet.Body>
    </Sheet.Root>
  )
}
